import LocationsTableReducer from "./reducers/LocationsTableReducer";
import LocationsSaga from "./saga";

import IConfig from "interfaces/IConfig";
import store from "rootStore";
import { permissionsType, routingType } from "types/configTypes";
import AsyncComponent from "ui/AsyncComponent";

export const moduleName = "Inventory.locations";
export const url = "locations";
export const groupsUrl = `${url}/groups`;

const getConfig = (permissions: permissionsType, parentUrl: string) => {
    const config: IConfig = {
        active: false,
        routing: [],
        url,
    };

    let routing: routingType = [];

    if (permissions["inventory.locations.read"]) {
        config.active = true;

        store.reducerManager?.add(
            "InventoryLocationTable",
            LocationsTableReducer
        );
        store.injectSaga?.("LocationsSaga", LocationsSaga);
        routing.push({
            path: url,
            element: (
                <AsyncComponent path="Inventory/Locations/pages/LocationsIndexPage" />
            ),
        });
    }

    if (permissions["inventory.locations.create"]) {
        routing.push({
            path: `${url}/create`,
            element: (
                <AsyncComponent path="Inventory/Locations/pages/LocationsCreatePage" />
            ),
        });
    }
    if (permissions["inventory.locations.update"]) {
        routing.push({
            path: `${url}/:id/edit`,
            element: (
                <AsyncComponent path="Inventory/Locations/pages/LocationsEditPage" />
            ),
        });
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => parentUrl + "/" + item.path);
    }

    return { config, routing };
};

export default getConfig;
